export default __webpack_public_path__ + "static/PublicaSans-Regular-d66cc682313985fb392d2d2dde522799.woff2";